var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modalNotLoggedIn",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modalNotLoggedInTitle",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "modal-body text-center d-flex flex-column justify-content-center"
              },
              [
                _c("p", [_vm._v(_vm._s(_vm.translate.home.needToLogin))]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { href: _vm.regionRelativeUrl("/users/login/") }
                  },
                  [_vm._v(_vm._s(_vm.translate.login.login))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-outline-secondary mt-3",
                    attrs: {
                      href: _vm.regionRelativeUrl("/users/registration/")
                    }
                  },
                  [_vm._v(_vm._s(_vm.translate.home.registerNow))]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "aria-label": "Close",
            "data-dismiss": "modal"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3178e22", { render: render, staticRenderFns: staticRenderFns })
  }
}